import React from 'react';
import { ContentView } from '@levelapp/softfabric';
import ToastWebViewStyle from './ToastWebViewStyle';
import ToastWebViewModel from './ToastWebViewModel';
import { Animated } from 'react-native';
export default class ToastWebView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new ToastWebViewModel(this), new ToastWebViewStyle(this));
    }
    /* RENDERING */
    render() {
        return (React.createElement(Animated.View, { style: [{ backgroundColor: this.binding.getColorForType() }, this.style.container, { transform: [{ translateX: this.state.translateX }], opacity: this.state.opacity }] }, this.props.children));
    }
}
